export const GROUPED_ITEM_SPACING_CLASS_MAP = {
    none: "",
    normal: "mb-1",
    expanded: "mb-2.5",
};
//# sourceMappingURL=constants.js.map